/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import memberClient from 'member-api';

const RESOURCE_ROOT_ADDRESSSERVICE = 'addressbook';
const RESOURCE_VERSION_ADDRESS = '/v2';
const RESOURCE_PAGE_ADDRESSSERVICE = '/contacts';
const RESOURCE_PAGE_ENTRIES = '/entries';
const RESOURCE_PAGE_ACTION = '/address';

const updateAddressBook = ({
    wcEnv, jwtToken, contactId, addressBookEntry, addressBookEntryId,
}) => {
    const resourcePage = `${RESOURCE_ROOT_ADDRESSSERVICE}${RESOURCE_VERSION_ADDRESS}${RESOURCE_PAGE_ADDRESSSERVICE}/${contactId}${RESOURCE_PAGE_ENTRIES}/${addressBookEntryId}${RESOURCE_PAGE_ACTION}`;
    return memberClient.performPut(wcEnv, resourcePage, jwtToken, addressBookEntry)
        .then((response) => response);
};

export default updateAddressBook;
